import React from "react";

function NotificationListLoading() {
  return (
    <div className="p-3 p-md-4 text-center text-muted">
      <div className="spinner-border spinner-border-sm me-2" role="status" />
      Loading...
    </div>
  );
}

export default NotificationListLoading;
